import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ESGDataSetService {
  static getTopic(id, cat) {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_TOPIC
      .replace('<id>', id)
      .replace(cat ? '<category>' : '&category=<category>', cat ?? '')
    );
  }

  static addTopic(payload) {
    return HttpUtil.post(
      API_ROUTES.ESG_DATASET.ADD_TOPIC,
      payload
    );
  }

  static updateTopic(payload) {
    return HttpUtil.put(
      API_ROUTES.ESG_DATASET.UPDATE_TOPIC,
      payload
    );
  }

  static getMetric(id, topicId, standard = '') {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_METRIC
      .replace("<topicId>", topicId)
      .replace(id > 0 ? "<id>" : "&id=<id>", id > 0 ? id :'')
      .replace(standard ? "<standard>" : "&standard=<standard>", standard ?? '')
    );
  }

  static addMetric(topicId, payload, parentId = '') {
    return HttpUtil.post(
      API_ROUTES.ESG_DATASET.ADD_METRIC
      .replace("<topicId>", topicId)
      .replace(parentId ? '<parentId>' : '&parentId=<parentId>', parentId ?? ''),
      payload
    );
  }

  static updateMetric(payload) {
    return HttpUtil.put(
      API_ROUTES.ESG_DATASET.UPDATE_METRIC,
      payload
    );
  }

  static addDP(metricId, payload) {
    return HttpUtil.post(
      API_ROUTES.ESG_DATASET.ADD_DP
      .replace("<metricId>", metricId),
      payload
    );
  }

  static updateDP(payload) {
    return HttpUtil.put(
      API_ROUTES.ESG_DATASET.UPDATE_DP,
      payload
    );
  }

  static getDP(id, metricId, standard = '') {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_DP
      .replace("<metricId>", metricId)
      .replace(id > 0 ? "<id>" : "&id=<id>", id > 0 ? id :'')
      .replace(standard ? "<standard>" : "&standard=<standard>", standard ?? '')
    );
  }

  static deleteTopic(id) {
    return HttpUtil.delete(
      API_ROUTES.ESG_DATASET.DELETE_TOPIC.replace("<id>", id)
    );
  }

  static deleteMetric(id) {
    return HttpUtil.delete(
      API_ROUTES.ESG_DATASET.DELETE_METRIC.replace("<id>", id)
    );
  }

  static deleteDP(id) {
    return HttpUtil.delete(
      API_ROUTES.ESG_DATASET.DELETE_DP.replace("<id>", id)
    );
  }

  static saveEquation(metricId, payload) {
    return HttpUtil.post(
      API_ROUTES.ESG_DATASET.UPSERT_EQ.replace('<metricId>', metricId),
      payload
    );
  }

  static getEquation(topicId) {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_EQ
      .replace("<topicId>", topicId)
    );
  }

  static getPlatformStandard() {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_PLATFORM_STD
    );
  }

  static getPlatformStandardCodes(standard, category, platformCode) {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_PLATFORM_STD_CODE
      .replace('<standard>', standard)
      .replace('<category>', category)
      .replace('<platformCode>', platformCode)
    );
  }

  static savePlatformCodeMapping(payload) {
    return HttpUtil.post(
      API_ROUTES.ESG_DATASET.MAP_PLATFORM_CODE,
      payload
    );
  }

  static deletePlatformCodeMapping(standard, platformCode) {
    return HttpUtil.delete(
      API_ROUTES.ESG_DATASET.DELETE_PLATFORM_CODE_MAP
      .replace('<standard>', standard)
      .replace('<platformCode>', platformCode)
    );
  }

  static reorderTopic(topicId, payload) {
    return HttpUtil.put(
      API_ROUTES.ESG_DATASET.REORDER_TOPIC.replace("<topicId>", topicId),
      payload
    );
  }

  static reorderMetric(metricId, payload) {
    return HttpUtil.put(
      API_ROUTES.ESG_DATASET.REORDER_METRIC.replace("<metricId>", metricId),
      payload
    );
  }

  static reorderDP(dataPointId, payload) {
    return HttpUtil.put(
      API_ROUTES.ESG_DATASET.REORDER_DP.replace("<dataPointId>", dataPointId),
      payload
    );
  }
}
